<template>
    <div class="contracted-volume-progress-bar" :class="!showComponents ? 'contracted-volume-progress-bar-opacity' : ''">
        <h3>
            {{ translate('title') }}
        </h3>
        <el-card>
            <div class="contracted-volume-progress-bar__container" v-if="form.contract_data.volume">
                <div style="width: 100%">
                    <el-progress
                        :percentage="volumePercentage"
                        :show-text="false"
                        :status="
                            volumePercentage >= 100 ? 'success' : 'warning'
                        "
                    ></el-progress>
                </div>
                <div class="progress-total">
                    {{ formatters.formatNumber(volumeAdded) }} / {{ formatters.formatNumber(form.contract_data.volume) }}
                </div>
            </div>
            <span>
                <span v-if="form.contract_data.volume">
                    <i
                        :class="`el-icon-${
                            volumePercentage === 100 ? 'success' : 'warning'
                        }`"
                    ></i>
                    <span v-if="volumePercentage === 100">
                        {{ translate('volume_completed_tip') }}
                    </span>
                    <span v-else>
                        {{
                            translate('remaining_volume_to_contract_tip', {
                                volume: volumeRemaining
                            })
                        }}
                    </span>
                </span>
                <span v-else>
                    <i
                        :class="`el-icon-${
                            volumePercentage === 100 ? 'success' : 'warning'
                        }`"
                    ></i>
                    {{ translate('volume_contracted_tip') }}
                </span>
            </span>
        </el-card>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Formatters from '@/utils/formatters';

export default {
    name: 'ContractedVolumeProgressBar',
    data() {
        return {
            formatters: Formatters
        };
    },
    computed: {
        ...mapState('traceabilityContractModule', ['form']),
        ...mapGetters('traceabilityContractModule', {
            volumePercentage: 'getVolumePercentage',
            volumeRemaining: 'getVolumeRemaining',
            volumeAdded: 'getVolumeAdded'
        }),
        showComponents() {
            return this.volumePercentage > 0;
        }
    },
    methods: {
        translate(key, params = {}) {
            const base = 'contrato_rastreabilidade.messages.contract_volume';
            return this.$t(`${base}.${key}`, params);
        }
    }
};
</script>

<style scoped lang="scss">
h3 {
    margin: 16px 0;
    color: #3B3B3B;
    font-weight: 500;
    font-size: 16px;
}
.contracted-volume-progress-bar {
    width: 100%;

    .contracted-volume-progress-bar__container {
        display: flex;
        flex-direction: row;
        gap: 20px;
        justify-content: space-between;
        align-items: center;
    }

    .progress-total {
        text-wrap: nowrap;
    }

    .el-icon-warning {
        color: #f0ad4e;
    }

    .el-icon-success {
        color: #5cb85c;
    }
}
.contracted-volume-progress-bar-opacity {
    opacity: 0.5;
}
</style>
